import { useState, useEffect, useCallback } from 'react';

import DynaLoader from './DynaLoader';

import TokenList from './TokenList';

import { fetchRecentTokenIds } from '../utils/BlockchainAPI';
import DynaSpan from './DynaSpan';
import { handleError } from '../utils/ErrorHandler';

const RecentStripesComponent = () => {
  const [loading, setLoading] = useState(true);
  const [tokenIds, setTokenIds] = useState<any[]>([]);

  const fetchTokens = useCallback(async () => {
    console.log("[RecentStripesComponent] Fetching tokens...");
    try {

      // Public data -- read straight from the chain, no wallet required.
      const tokensList = await fetchRecentTokenIds(12);

      setLoading(false);
      setTokenIds(tokensList);

    } catch (err: any) {
      console.log("[RecentStripesComponent] Error fetching tokens: " + err);
      setLoading(false);
      setTokenIds([]);
      handleError(err);
    }
  }, []);

  useEffect(() => {
    fetchTokens();
  }, [fetchTokens]);

  console.log("RENDER TOKEN IDS: " + tokenIds);

  if (loading === true) {
    return (
      <div className="content">
        <h1>Recently minted <DynaSpan /> NFTs</h1>
        <DynaLoader variant="block" />
      </div>
    );
  } else if (tokenIds === null || tokenIds.length === 0) {
    return (
      <div className="content">
        <h1>Recently minted <DynaSpan /> NFTs</h1>
        No stripes have been minted yet.
      </div>
    );
  } else {
    return (
      <div className="content">
        <h1>Recently minted <DynaSpan /> NFTs</h1>
        <TokenList tokens={tokenIds} />
      </div>
    );
  }
}

export default RecentStripesComponent;